import React, { useRef, useState} from "react";
import {Spin, Tooltip} from 'antd';
import axios from "axios";
import {request} from "../../util/request";
import {GLOBAL_KNOWLEDGE_SEARCH_API} from "../../config/api";
import {removeHTML} from "jzfz-web-utils";
import {
    LoadingOutlined,
} from '@ant-design/icons';
import './style.less';


const CancelToken = axios.CancelToken;


interface AbstractProps {
    type: number;    // 知识类型
    pkid: string;  // 知识pkid
    children: React.ReactNode;
}


/**
 * 摘要提示组件
 * @param props
 * @constructor
 */
const Abstract = (props: AbstractProps) => {
    const { type, pkid, children } = props;
    const [content, setContent] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    // 取消列表查询请求token
    const queryCancelRef = useRef<any>(null);


    /**
     * 显隐触发
     */
    const visibleChangeHandle = (visible: boolean) => {
        if (queryCancelRef.current) {
            queryCancelRef.current();
        }
        if (visible) {
            setLoading(true);
            request('/api/knowledge/summary/get', {appType: type, knowledgePkId: pkid}, {
                method: 'get',
                baseURL: GLOBAL_KNOWLEDGE_SEARCH_API,
                cancelToken: new CancelToken((c: any) => queryCancelRef.current = c)
            }).then((res: any) => {
                setContent(res.data);
            }).finally(() => {
                setLoading(false);
            })
        }else {
            setLoading(false);
            setContent('');
        }
    }


    return (
        <Tooltip
            overlayClassName="global-abstract-tooltip-wrap"
            placement="topLeft"
            title={
                <Spin spinning={loading} indicator={<LoadingOutlined style={{color: '#E8636D'}} />}>
                    <h3 className="abstract-tooltip-head">摘要：</h3>
                    <div className="abstract-tooltip-content">{removeHTML(content) || '暂无~'}</div>
                </Spin>
            }
            mouseEnterDelay={0.5}
            color="#fff"
            align={{offset: [0, 6]}}
            onVisibleChange={visibleChangeHandle}
        >{children}
        </Tooltip>
    )
}


export default Abstract;
